export default __webpack_public_path__ + "static/media/Memorabilia5.952771be.png";